import TooltipContainer from "../../../Components/UiKits/Tooltip/TooltipContainer";

const Tooltip = () => {
  return <TooltipContainer />;
};

export default Tooltip;
